export default __webpack_public_path__ + "static/media/set-live-overlay.c87b7eea.png";